// TODO: delete this file

import React from 'react';

interface LayoutContextState {
    instagramUsername: string;
    accountColor: { name: string; bgColor: string; ringColor: string; hoverColor: string; };
    activePeriod: 'Monthly' | 'Yearly';
    setActivePeriod: (period: 'Monthly' | 'Yearly') => void;
    selectedPlan: any; // replace with the actual type of selectedPlan
    setSelectedPlan: (plan: any) => void; // replace any with the actual type of plan
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
    setErrorMessage: (message: string | null) => void;
}

export const SetupLayoutContext = React.createContext<LayoutContextState>({} as LayoutContextState);